import React, { forwardRef, useImperativeHandle, useState } from "react";
import makeAnimated from "react-select/animated";
import CreatableSelect from "react-select/creatable";

export default forwardRef((props, ref) => {
  const [selectOptionsValue, setSelectOptionsValue] = useState(
    props.value != null && props.value !== ""
      ? props.value?.map((label) => {
          return {
            label: label,
            value: label,
          };
        })
      : [],
  );
  const [selectOptionsInputValue, setSelectOptionsInputValue] = useState("");

  /* Component Editor Lifecycle methods */
  useImperativeHandle(ref, () => {
    const tempValue = [];
    selectOptionsValue?.forEach((selection) => {
      tempValue.push(selection.value);
    });
    // return tempValue == [] ? null : tempValue;
    return {
      // the final value to send to the grid, on completion of editing
      getValue() {
        const tempValue = [];
        selectOptionsValue?.forEach((selection) => {
          tempValue.push(selection.value);
        });
        return tempValue.length === 0 ? null : tempValue;
      },
    };
  });

  const animatedComponents = makeAnimated();

  const handleKeyDown = (event) => {
    if (!selectOptionsInputValue) return;
    switch (event.key) {
      case "Enter":
      case "Tab":
      case "ArrowRight":
        if (
          !selectOptionsValue
            ?.map((o) => o.label)
            .includes(selectOptionsInputValue)
        ) {
          var temp = [
            ...selectOptionsValue,
            { label: selectOptionsInputValue, value: selectOptionsInputValue },
          ];
          setSelectOptionsValue(temp);
        }
        setSelectOptionsInputValue("");
        event.preventDefault();
        break;
      default:
        break;
    }
  };

  return (
    <div style={{ width: props.column?.actualWidth }}>
      <CreatableSelect
        // components={{ DropdownIndicator: null }}
        components={animatedComponents}
        inputValue={selectOptionsInputValue}
        isClearable
        isMulti
        menuIsOpen={false}
        onChange={(newValue) => setSelectOptionsValue(newValue)}
        onInputChange={(newValue) => setSelectOptionsInputValue(newValue)}
        onKeyDown={(e) => handleKeyDown(e)}
        placeholder="Type something and press enter..."
        value={selectOptionsValue}
      />

      {/* <Select
        ref={refInput}
        closeMenuOnSelect={false}
        components={animatedComponents}
        isMulti
        options={props.values.map((value) => {
          return { value: value, label: value };
        })}
        value={value}
        onChange={(event) => changeHandler(event)}

        //   onKeyDown={(event) => onKeyDown(event)}
      /> */}
    </div>
  );
});
